import { i as d, x as s, s as u } from "../../../lit-element-6iugfgmM.js";
import { e as c } from "../../../custom-element-wk-AooBb.js";
import { n as m } from "../../../property-BWlAHqg_.js";
import "../../../query-assigned-elements-B8U94KLQ.js";
import "../../../sp-action-button-CjSKZ-qO.js";
import "@spectrum-web-components/icons-workflow/icons/sp-icon-text-size.js";
import "../../../sp-overlay-C7imRS_0.js";
import "../../../sp-popover-DFTTgsX0.js";
import "../../../sp-slider-LOA7HzsD.js";
import f from "../../../events/FontSizeChangeEvent.js";
import { Localize as z } from "../../../lib/I18N.js";
const v = { "font-size-slider.text-size-label": "Text Size" }, h = d`:host{--mod-slider-font-size: 14px;--mod-slider-min-size: 150px}[part=default-view]{display:none}div,sp-action-button{align-items:center;display:flex;justify-content:space-between}sp-popover{padding:0 12px}`;
var x = Object.defineProperty, b = Object.getOwnPropertyDescriptor, a = (i, t, n, r) => {
  for (var l, e = r > 1 ? void 0 : r ? b(t, n) : t, p = i.length - 1; p >= 0; p--) (l = i[p]) && (e = (r ? l(t, n, e) : l(e)) || e);
  return r && e && x(t, n, e), e;
};
let o = class extends z(u, v) {
  constructor() {
    super(...arguments), this.handleSliderInput = (i) => {
      const t = i.target;
      this.fontSizeValue = t.value, this.dispatchEvent(new f(this.fontSizeValue));
    };
  }
  static get styles() {
    return h;
  }
  render() {
    return s`${this.renderMobileSlider()} ${this.renderDefaultSlider()}`;
  }
  renderMobileSlider() {
    return s`<div part="compact-view"><sp-action-button id="slider-trigger" label="${this.t("font-size-slider.text-size-label")}" quiet size="xs"><sp-icon-text-size slot="icon"></sp-icon-text-size></sp-action-button><sp-overlay trigger="slider-trigger@click" placement="bottom"><sp-popover>${this.renderFontSizer()}</sp-popover></sp-overlay></div>`;
  }
  renderDefaultSlider() {
    return s`<div part="default-view">${this.renderFontSizer()}</div>`;
  }
  renderFontSizer() {
    return s`<sp-slider class="text-size-slider" label="${this.t("font-size-slider.text-size-label")}" max="120" min="14" value="${this.fontSizeValue || 36}" @input="${this.handleSliderInput}"></sp-slider>`;
  }
};
a([m()], o.prototype, "fontSizeValue", 2), o = a([c("af-font-size-slider")], o);
const M = o;
export {
  M as default
};
//# sourceMappingURL=FontSizeSlider.js.map
